// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"384e5ed9","78":"367051f6","113":"e578eacc","287":"0595095a","319":"2ce41da9","337":"86f4bac2","372":"16cefb2f","481":"2cd409e8","488":"3993ea15","489":"bb54d9de","783":"d64c37b2","877":"415c579a","919":"ba2c350b","921":"f694ec7d","981":"7c6af543"}[chunkId] + ".chunk.js";
};